<template>
  <div class="not_draw_toast_bg" v-show="toastShow">
    <div class="not_draw_toast_centent_bg">
      <div class="not_draw_toast_centent_title">很抱歉！</div>
      <div class="not_draw_toast_centent_title_c">
        由于本期活动参与人数少于{{
          minPerson
        }}人，活动取消开奖，您的幸运码已转为幸运值。
        诚邀您参与下期活动，可邀请好友一起参与活动，并有机会获得最终大奖！
      </div>
      <button
        class="button not_draw_toast_centent_title_btn"
        @click="$emit('isshowaction')"
      >
        确定
      </button>
    </div>
  </div>
</template>

<script lang="ts">
import { Vue, Options } from "vue-class-component";
@Options({
  props: {
    toastShow: Boolean,
    minPerson: Number
  },
  emits: {
    isshowaction: () => {
      return true;
    }
  }
})
/*开奖时刻，首次进来，没有开奖*/
export default class NotDrawToast extends Vue {
  close() {
    console.log("NotDrawToastClose");
  }
}
</script>

<style scoped lang="less">
@import "../../style/BaseStyle.less";
.not_draw_toast_bg {
  position: fixed;
  z-index: 2000;
  left: 0px;
  right: 0;
  top: 44px;
  bottom: 0;
  text-align: center;
  background: rgba(17, 17, 17, 0.7);
  height: 100%;
  width: 100%;
  .not_draw_toast_centent_bg {
    width: 325px;
    height: 243px;
    position: fixed;
    z-index: 2100;
    left: 50%;
    top: 50%;
    transition: all 0.5s;
    -webkit-transform: translateX(-50%) translateY(-50%);
    -moz-transform: translateX(-50%) translateY(-50%);
    -ms-transform: translateX(-50%) translateY(-50%);
    -o-transform: translateX(-50%) translateY(-50%);
    transform: translateX(-50%) translateY(-50%);
    text-align: center;
    border-radius: 10px;
    background-color: white;
    .not_draw_toast_centent_title {
      margin: 0 auto;
      margin-top: 30px;
      font-size: 17px;
      color: #111111;
      font-weight: bold;
    }
    .not_draw_toast_centent_title_c {
      margin: 20px 20px;
      font-size: 14px;
      color: #111111;
      text-align: left;
    }
    .not_draw_toast_centent_title_btn {
      background-color: #f64746;
      color: #ffffff;
      font-size: 15px;
      padding: 10px 85px;
      border-radius: 30px;
    }
  }
}
</style>
